import React, {Component} from 'react';
import axios from 'axios';
import Helmet from 'react-helmet';

const initialState = {
  pin: '',
  rePin: '',
  complete: false,
  errorMap: null,
  loading: false,
  showPwd: false
}

class PinChange extends Component {
  state = initialState;

  componentDidMount() {

    // GA計測用データレイヤースクリプトを追加する
    window.addDataLayerScript('jmbauth_pin_change');
  }

  // [変更する]ボタン押下時処理
  pinSetting = async () => {

    // Cookieからl_sidを取得する
    let l_sid = window.getCookieValue('l_sid');
    // アクショントークン格納変数の宣言
    let actionToken = null;

    // SDK呼出(アクションレポート)
    try{
      // アクションのレポート作成
      const actionPromise = window.tsPlatform.drs.triggerActionEvent("account_details_change_pinchange", { correlationId: l_sid });

      // タイムアウト判定関数
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Action token request timed out'));
        }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
      });

      // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
      const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
      actionToken = actionResponse ? actionResponse.actionToken : null;
    }catch(e){
      // タイムアウト時の処理
      if (e.message.includes('timed out')) {
        // エラー文言を、アクショントークン変数に設定
        actionToken = 'jallogin_transmit_api_timeout';
      }
    }

    const { pin, rePin } = this.state;

    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // バリデーションチェックを行う
    if (pin === '') {
      this.setState({ errorMap: { ERROR: messageList.pinChange.M012_errorMessage001, errorId: ['pin'] }});
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    if (pin !== rePin) {
      this.setState({ errorMap: { ERROR: messageList.pinChange.M013_errorMessage002, errorId: ['pin', 'rePin'] }, pin: '', rePin: ''
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";
      // 処理を終了する。
      return;
    }

    // PIN設定要求を行う
    try {
      // ローディング開始
      this.setState({ loading: true });

      // PINコード設定API
      axios
        .put( process.env.REACT_APP_URL_CO_SC_API_PIN_CHANGE,
          {
            pin: pin
          },
          {headers: {'accept-language': window.changeLang(sessionStorage.getItem("lang")),
                     'Cache-Control': 'no-store',
                     'Pragma': 'no-cache'}}
        )
      .then( response => {

        this.setState({ complete: true, loading: false });
        // GA計測用データレイヤースクリプトを追加する
        window.addDataLayerScript('jmbauth_pin_change_completion');
      })
      .catch( error => {
        if ( error.response ) {
          if ( error.response.status === 400 ) {
            this.setState({ errorMap:
              { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pinChange.M014_errorMessage003 },
              loading: false, pin: '', rePin: ''
            });
            // エラーメッセージ表示領域に遷移する
            window.location="#JS_error";
          }
          else if ( error.response.status === 401 ) {
            this.setState({ errorMap:
              { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pinChange.M014_errorMessage003 },
              loading: false, pin: '', rePin: ''
            });
            // エラーメッセージ表示領域に遷移する
            window.location="#JS_error";
          }
          else if ( error.response.status === 500 ) {

            // エラー画面に遷移し、処理を終了する
            this.props.history.push({
              pathname:`${process.env.REACT_APP_CONTEXT_PATH}/error`
            });
          }
          else {
            this.setState({ errorMap:
              { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.pinChange.M014_errorMessage003 },
              loading: false, pin: '', rePin: ''
            });
            // エラーメッセージ表示領域に遷移する
            window.location="#JS_error";
          }
        }
        else {
          this.setState({ errorMap:
            { ERROR: messageList.pinChange.M014_errorMessage003 },
            loading: false, pin: '', rePin: ''
          });
          // エラーメッセージ表示領域に遷移する
          window.location="#JS_error";
        }
      });

    } catch ( err ) {
      console.error(err);
      this.setState({ errorMap:
        { ERROR: messageList.pinChange.M014_errorMessage003 },
        loading: false, pin: '', rePin: ''
      });
      // エラーメッセージ表示領域に遷移する
      window.location="#JS_error";

    } finally {
    }
  }

  // パスワード表示切り替え処理
  swhichPwdShow = e => {
    this.setState({ showPwd: e.currentTarget.checked });
  }

  handleChange = e => {
    this.setState({ [e.currentTarget.name]: e.currentTarget.value.trim() });
  }

  // 画面をクローズする
  close = e => {
    window.open('about:blank','_self').close();
  }

  render() {

    // 文言リストを取得する
    let messageList = JSON.parse(sessionStorage.getItem('messageList'));

    // PIN設定完了画面表示
    if (this.state.complete){
      return (
        <section className="content">
          <Helmet
            title={messageList.pinChangeCompletion.M001_browserTitle} >
          </Helmet>

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">{messageList.pinChangeCompletion.M002_pageTitle}</h1>
          </div>

          <div className="contentInner">
            {/* 操作ボタン表示部 */}
            <div className="buttonLayout">
              <div className="buttonWrap buttonWrap--center">
                <div className="ds-button ds-button--tertiary ds-button--large">
                  <button className="ds-button__trigger" type="button" onClick={this.close}>
                    <span className="ds-button__label">{messageList.pinChangeCompletion.M003_close}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

        </section>
      );
    }

    // PIN設定画面表示
    else {
      return (
        <section className="content">
          <Helmet
            title={messageList.pinChange.M001_browserTitle} >
          </Helmet>

          { // Loadingモーダル表示
            this.state.loading &&
            <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading"/></div>
          }

          {/* 画面タイトル表示部 */}
          <div className="ds-heading ds-heading--lg">
            <h1 className="ds-heading__title">{messageList.pinChange.M002_pageTitle}</h1>
          </div>

          <div className="contentInner">
            <div id="JS_error">
            { // エラーメッセージ表示
              (this.state.errorMap && this.state.errorMap.ERROR) &&
              <div className="ds-inlineNote ds-inlineNote--attention u-mb-32--pc" role="alert" aria-live="assertive">
                <div className="ds-inlineNote__details">
                  <div className="ds-inlineNote__summary">
                    <h2 className="ds-inlineNote__heading">
                      <span className="ds-inlineNote__headingIcon">
                        <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.pinChange.M003_errorIconText}>
                          <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                        </svg>
                      </span>
                      <span className="ds-inlineNote__headingLabel">{messageList.pinChange.M004_errorBoxTitle}</span>
                    </h2>
                  </div>
                  <div className="ds-inlineNote__content">
                    <p className="ds-text">{this.state.errorMap.ERROR}</p>
                  </div>
                </div>
              </div>/* /ds-inlineNote */
            }
            </div>

            <div className="formPanel">
              <div className="formPanel__inner">
                <form name="form">

                  <div className="formList">
                    {/* 電話用パスワード */}
                    <div className="formList__line">
                      <div className="formWrap">
                        <label className="formLabel" htmlFor="LB_input-password-1">
                          <span className="formLabel__text">{messageList.pinChange.M005_pinPassword}</span>
                        </label>
                        <input type={ this.state.showPwd ? "text" : "password"} id="LB_input-password-1"
                          className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('pin') ?
                          "ds-textfield is-error" : "ds-textfield"}
                          maxLength="6"
                          aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('pin') ? "true" : "false"}
                          aria-describedby="LB_input-password-1-helper"
                          autocomplete="new-password" inputMode="numeric" required
                          name="pin" value={this.state.pin} onChange={this.handleChange}/>
                        <span id="LB_input-password-1-helper" className="helperText">{messageList.pinChange.M015_helperText}</span>
                      </div>
                    </div>

                    {/* 電話用パスワードの再入力 */}
                    <div className="formList__line">
                      <div className="formWrap">
                        <label className="formLabel" htmlFor="LB_input-password-2">
                          <span className="formLabel__text">{messageList.pinChange.M006_rePinPassword}</span>
                        </label>
                        <input type={ this.state.showPwd ? "text" : "password"} id="LB_input-password-2"
                          className={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('rePin') ?
                          "ds-textfield is-error" : "ds-textfield"}
                          maxLength="6"
                          aria-invalid={ this.state.errorMap && this.state.errorMap.errorId && this.state.errorMap.errorId.includes('rePin') ? "true" : "false"}
                          autocomplete="new-password" inputMode="numeric" required
                          name="rePin" value={this.state.rePin} onChange={this.handleChange}/>
                        {/* パスワードを表示する */}
                        <label className="ds-checkbox">
                          <input className="ds-checkbox__input" type="checkbox" name="checkPassword"
                            aria-controls="LB_input-password-1 LB_input-password-2" onChange={this.swhichPwdShow}/>
                          <span className="ds-checkbox__partsWrap">
                            <span className="ds-checkbox__parts" role="presentation"></span>
                            <span className="ds-checkbox__text">{messageList.pinChange.M007_showPassword}</span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>

                  {/* 操作ボタン表示部 */}
                  <div className="buttonLayout">
                    <div className="buttonWrap buttonWrap--center">
                      <div className="ds-button ds-button--primary ds-button--large">
                        <button className="ds-button__trigger" type="button" formNoValidate onClick={this.pinSetting}>
                          <span className="ds-button__label">{messageList.pinChange.M008_update}</span>
                        </button>
                      </div>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>

          {/* 案内表示部 */}
          <div className="contentInner">
            <div className="ds-heading ds-heading--sm">
              <h2 className="ds-heading__title">{messageList.pinChange.M009_notices}</h2>
            </div>
            <ul className="ds-listText ds-listText--md">
              <li className="ds-listText__item">{messageList.pinChange.M010_notice001}</li>
            </ul>
          </div>

        </section>
      );
    }
  }
}

export default PinChange
